<template>
  <VWidget
    :title="$t('Product Restrictions')"
  >
    <v-layout
      slot="widget-content"
      row
      wrap
    >
      <v-flex
        xs12
        px-4>
        <application-select v-model="product.application"/>
      </v-flex>
      <v-flex
        xs12
        px-4>
        <customer-group-select v-model="product.customer_group"/>
      </v-flex>
    </v-layout>
  </VWidget>
</template>

<script>
import ApplicationSelect from '@/components/form/ApplicationSelect'
import CustomerGroupSelect from '@/modules/Products/components/CustomerGroupSelect'

export default {
  name: 'ProductSingleApplication',

  components: {
    CustomerGroupSelect,
    ApplicationSelect
  },

  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>
